import React from "react";
import { Phone, MessageCircle, MapPin, Clock, Instagram, Facebook, Mail } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { COMPANY } from "@/lib/translations";

const Contact = () => {
  const { t } = useLang();
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 sm:py-32 bg-[color:var(--bg-secondary)]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="label-eyebrow">{t.contact.eyebrow}</p>
          <h2
            data-testid="contact-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 text-white tracking-tight"
          >
            {t.contact.title}
          </h2>
          <p className="mt-5 text-zinc-400">{t.contact.subtitle}</p>

          <div className="mt-6 flex items-center justify-center gap-3">
            <a
              href={COMPANY.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-instagram"
              aria-label="Instagram Faustitur"
              className="social-icon"
            >
              <Instagram className="h-4 w-4" />
            </a>
            <a
              href={COMPANY.facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-facebook"
              aria-label="Facebook Faustitur"
              className="social-icon"
            >
              <Facebook className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <a
            href={COMPANY.telLink}
            data-testid="contact-phone-card"
            className="bento-card p-8 group block"
          >
            <Phone className="h-6 w-6 text-[color:var(--gold)]" />
            <p className="mt-6 text-[10px] tracking-[0.25em] uppercase text-zinc-500">
              {t.contact.phone}
            </p>
            <p className="mt-2 font-display text-xl text-white group-hover:text-[color:var(--gold)] transition-colors break-all">
              {COMPANY.phoneDisplay}
            </p>
            <p className="mt-2 text-sm text-zinc-400">Tap to call</p>
          </a>

          <a
            href={COMPANY.whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="contact-wa-card"
            className="bento-card p-8 group block"
          >
            <MessageCircle className="h-6 w-6 text-[color:var(--whatsapp)]" />
            <p className="mt-6 text-[10px] tracking-[0.25em] uppercase text-zinc-500">
              WhatsApp
            </p>
            <p className="mt-2 font-display text-xl text-white group-hover:text-[color:var(--whatsapp)] transition-colors break-all">
              {COMPANY.phoneDisplay}
            </p>
            <p className="mt-2 text-sm text-zinc-400">Chat in seconds</p>
          </a>

          <a
            href={`mailto:${COMPANY.email}`}
            data-testid="contact-email-card"
            className="bento-card p-8 group block"
          >
            <Mail className="h-6 w-6 text-[color:var(--gold)]" />
            <p className="mt-6 text-[10px] tracking-[0.25em] uppercase text-zinc-500">
              Email
            </p>
            <p className="mt-2 font-display text-xl text-white group-hover:text-[color:var(--gold)] transition-colors break-all">
              {COMPANY.email}
            </p>
            <p className="mt-2 text-sm text-zinc-400">Send a message</p>
          </a>

          <div data-testid="contact-area-card" className="bento-card p-8">
            <MapPin className="h-6 w-6 text-[color:var(--teal)]" />
            <p className="mt-6 text-[10px] tracking-[0.25em] uppercase text-zinc-500">
              {t.contact.area}
            </p>
            <p className="mt-2 font-display text-xl text-white">{t.contact.areaValue}</p>
            <div className="mt-4 flex items-center gap-2 text-sm text-zinc-400">
              <Clock className="h-4 w-4 text-[color:var(--gold)]" /> {t.contact.hoursValue}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
